import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";

import { wordPressApi } from "../api/wordpress";
import { bookingSlice } from "./bookingSlice";
import { cartSlice } from "./cartSlice";

const reducer = combineReducers({
  [wordPressApi.reducerPath]: wordPressApi.reducer,
  [cartSlice.name]: cartSlice.reducer,
  [bookingSlice.name]: bookingSlice.reducer,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(wordPressApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
